"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayControls = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Pause_1 = __importDefault(require("@material-ui/icons/Pause"));
const PlayArrow_1 = __importDefault(require("@material-ui/icons/PlayArrow"));
const useStyles = (0, makeStyles_1.default)({
    playControls: {
        position: 'absolute',
        zIndex: 2,
        opacity: 0,
        transition: 'opacity 0.3s linear',
        transform: 'translate(-50%, -50%)'
    },
    active: {
        opacity: 1
    },
    playButton: {
        borderRadius: '50%',
        height: '64px',
        width: '64px',
        padding: 0
    },
    loader: {
        position: 'absolute',
        zIndex: 2
    },
    loaderContainer: {
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '64px',
        width: '64px'
    }
});
function PlayControls({ status, onClick, visible }) {
    const classes = useStyles();
    if (status === 'loading') {
        return (react_1.default.createElement(Box_1.default, { className: classes.loaderContainer },
            react_1.default.createElement(CircularProgress_1.default, { className: classes.loader })));
    }
    return (react_1.default.createElement(Box_1.default, { className: (0, clsx_1.default)(classes.playControls, visible && classes.active) },
        react_1.default.createElement(Button_1.default, { disableFocusRipple: true, disableRipple: true, className: classes.playButton, size: "small", onClick: onClick },
            status === 'playing' && (react_1.default.createElement(Pause_1.default, { fontSize: "large", style: { color: '#fff' } })),
            status === 'stopped' && (react_1.default.createElement(PlayArrow_1.default, { fontSize: "large", style: { color: '#fff' } })))));
}
exports.PlayControls = PlayControls;
//# sourceMappingURL=play-controls.js.map